import Collapsible from '../plugins/CollapsiblePlugin';

export default function initStaffBoxCollapsible() {
  const instances = [];

  document.querySelectorAll('.staff-box--collapsible').forEach((holder) => {
    const collapsible = new Collapsible({
      holder,
      opener: '.staff-box__opener',
      slide: '.staff-box__body',
      breakpoint: '99999px',
    });

    const opener = holder.querySelector('.staff-box__opener');
    if (opener) {
      // aria-haspopup is intended for menus/dialogs, not disclosure widgets
      opener.removeAttribute('aria-haspopup');

      // Keep aria-expanded in sync with slide-opened class via MutationObserver
      // CollapsiblePlugin's internal setAttribute is unreliable with breakpoint: '99999px'
      new MutationObserver(() => {
        opener.setAttribute('aria-expanded', String(holder.classList.contains('slide-opened')));
      }).observe(holder, { attributes: true, attributeFilter: ['class'] });
    }

    instances.push({ holder, collapsible });
  });

  const openByHash = (hash) => {
    if (!hash) return;
    const target = document.querySelector(hash);
    if (!target) return;
    const match = instances.find(({ holder }) => holder.contains(target) || holder.id === target.id);
    if (match && !match.collapsible.isOpened) {
      // Open without height animation so the browser can scroll to the correct
      // position without layout shifting under it
      match.holder.classList.add('slide-opened');
      match.collapsible.isOpened = true;
    }
  };

  openByHash(location.hash);
  window.addEventListener('hashchange', () => openByHash(location.hash));
}
